module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Legal")])]), _vm._v(" "), (_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.isActive(index)
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title"
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _vm._l((tab.content), function(item, index) {
      return _c('div', {
        key: index,
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('sk-panel', _vm._l((tab.content), function(content, index) {
        return _c('sk-layout', {
          key: index,
          attrs: {
            "row": "",
            "wrap": "",
            "reverse": "",
            "align-center": "",
            "gutter-40": ""
          }
        }, [_c('sk-flex', {
          attrs: {
            "xs12": "",
            "sm4": ""
          }
        }, [(content.summary) ? [_c('h3', [_vm._v("Explain in human language")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(content.summary))])] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
          class: content.summary ? 'summary' : '',
          attrs: {
            "xs12": "",
            "sm8": ""
          }
        }, [(content.name) ? _c('h2', [_vm._v(_vm._s(content.name))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('sk-list', {
          staticClass: "legal-list"
        }, _vm._l((content.points), function(point, index) {
          return _c('sk-list-item', {
            key: index
          }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(point.title) + "\n\t\t\t\t\t\t\t\t\t\t\t"), (point.points1) ? _c('sk-list', _vm._l((point.points1), function(item, index) {
            return _c('sk-list-item', {
              key: index
            }, [_vm._v(_vm._s(item))])
          })) : _vm._e()], 1)
        }))], 1)], 1)
      }))], 1)
    })], 2)
  }) : [_c('sk-tabs', [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabHeadings), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return (_vm.activeTab == index) ? _c('sk-panel', {
      key: index
    }, [_c('h2', [_vm._v(_vm._s(tab.name))]), _vm._v(" "), _c('p', {
      staticClass: "legal__copy",
      domProps: {
        "innerHTML": _vm._s(tab.copy)
      }
    }), _vm._v(" "), _vm._l((tab.content), function(content) {
      return _c('sk-layout', {
        key: content.title,
        attrs: {
          "row": "",
          "wrap": "",
          "reverse": "",
          "align-center": "",
          "gutter-40": ""
        }
      }, [_c('sk-flex', {
        attrs: {
          "xs12": "",
          "sm4": ""
        }
      }, [(content.summary) ? [_c('h4', [_vm._v("Explain in human language")]), _vm._v(" "), _c('p', {
        domProps: {
          "innerHTML": _vm._s(content.summary)
        }
      })] : _vm._e()], 2), _vm._v(" "), _c('sk-flex', {
        class: content.summary ? 'summary' : '',
        attrs: {
          "xs12": "",
          "sm8": ""
        }
      }, [(content.name) ? _c('h2', [_vm._v(_vm._s(content.name))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('sk-list', {
        staticClass: "legal-list"
      }, _vm._l((content.points), function(point, index) {
        return _c('sk-list-item', {
          key: index
        }, [_c('div', {
          domProps: {
            "innerHTML": _vm._s(point.title)
          }
        }), _vm._v(" "), (point.points1) ? _c('sk-list', _vm._l((point.points1), function(item, index) {
          return _c('sk-list-item', {
            key: index,
            domProps: {
              "innerHTML": _vm._s(item)
            }
          })
        })) : _vm._e()], 1)
      }))], 1)], 1)
    })], 2) : _vm._e()
  }))], 2)]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-513a04e5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/legal/legal.vue
// module id = 519
// module chunks = 0